import { parseBool } from "@/tools/parse";
export var convertToCreateDto = function (data) {
    var _a;
    var dtoData = {
        name: data.name,
        description: data.description,
        isIndoor: parseBool(data.isIndoor),
        isFree: parseBool(data.isFree),
        sports: data.sports.map(function (sport) { return sport.id; }),
        city: data.cityId[0],
        latitude: data.latitude,
        longitude: data.longitude,
        covers: (_a = data.coverFiles) === null || _a === void 0 ? void 0 : _a.map(function (el) { return el.id; }),
    };
    return dtoData;
};
export var convertToUpdateDto = function (data) {
    var _a;
    var dtoData = {
        name: data.name,
        description: data.description,
        isIndoor: parseBool(data.isIndoor),
        isFree: parseBool(data.isFree),
        sports: data.sports.map(function (sport) { return sport.id; }),
        city: data.cityId[0],
        latitude: data.latitude,
        longitude: data.longitude,
        covers: ((_a = data.coverFiles) === null || _a === void 0 ? void 0 : _a.filter(function (el) { return el.status !== "deleted"; }).map(function (el) { return el.id; })) || [],
    };
    return dtoData;
};
